import { Api } from './api';
import { BoostType } from '../redux/boosts/get-boosts.handler';

export class BoostsApi {
    private static readonly PATH = '/boosts';

    constructor(private readonly m_api: Api) {}

    public async getBoosts() {
        return this.m_api.get(BoostsApi.PATH);
    }

    public async buyBoost(boostType: BoostType) {
        return this.m_api.post(`${BoostsApi.PATH}/buy`, { boostType });
    }
}
